(function(){
  function formatMoney(cents, format){
    if(window.Shopify && Shopify.formatMoney){
      try{return Shopify.formatMoney(cents, format);}catch(e){}
    }
    return '$' + (cents/100).toFixed(2);
  }

  document.addEventListener('click', function(e){
    var thumb=e.target.closest('[data-pa-media-thumb]');
    if(thumb){
      var root=thumb.closest('[data-pa-product-root]');
      if(!root) return;
      root.querySelectorAll('[data-pa-media-thumb]').forEach(function(x){x.classList.remove('is-active')});
      root.querySelectorAll('[data-pa-media-panel]').forEach(function(x){x.classList.remove('is-active')});
      thumb.classList.add('is-active');
      var panel=root.querySelector('[data-pa-media-panel="'+thumb.getAttribute('data-pa-media-thumb')+'"]');
      if(panel) panel.classList.add('is-active');
      return;
    }

    var qty=e.target.closest('[data-pa-qty]');
    if(qty){
      var box=qty.closest('.pa-pdp-qty-box');
      var input=box && box.querySelector('input[name="quantity"]');
      if(!input) return;
      var current=parseInt(input.value,10)||1;
      input.value=Math.max(1,current+(qty.getAttribute('data-pa-qty')==='plus'?1:-1));
    }
  });

  document.addEventListener('change', function(e){
    if(!e.target.matches('[data-pa-option-radio]')) return;
    var root=e.target.closest('[data-pa-product-root]');
    if(!root) return;

    var selected=[];
    root.querySelectorAll('[data-pa-option-group]').forEach(function(group){
      var checked=group.querySelector('input[type="radio"]:checked');
      selected.push(checked?checked.value:'');
    });

    var jsonEl=root.querySelector('[data-pa-variants-json]');
    if(!jsonEl) return;
    var variants=JSON.parse(jsonEl.textContent);
    var match=variants.find(function(v){
      return v.options.every(function(opt,i){return opt===selected[i]});
    });
    if(!match) return;

    var idInput=root.querySelector('[data-pa-variant-id]');
    if(idInput) idInput.value=match.id;

    var moneyFormat=root.getAttribute('data-money-format') || '${{amount}}';
    var price=root.querySelector('[data-pa-current-price]');
    if(price) price.textContent=formatMoney(match.price,moneyFormat);

    var compare=root.querySelector('[data-pa-compare-price]');
    var badge=root.querySelector('[data-pa-discount-badge]');
    if(match.compare_at_price && match.compare_at_price>match.price){
      if(compare){
        compare.textContent=formatMoney(match.compare_at_price,moneyFormat);
        compare.hidden=false;
      }
      if(badge){
        badge.textContent=Math.round((match.compare_at_price-match.price)*100/match.compare_at_price)+'% Off';
        badge.hidden=false;
      }
    }else{
      if(compare) compare.hidden=true;
      if(badge) badge.hidden=true;
    }

    var add=root.querySelector('[data-pa-add-button]');
    if(add){
      add.disabled=!match.available;
      add.textContent=match.available?add.getAttribute('data-available-text'):add.getAttribute('data-sold-text');
    }
  });
})();